// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__i-TRb","right":"styles_right__17gzK"};